<template lang="pug">
#app
  Items
  Modal
  Loading
  Contact
  Form
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Items from "../../components/items.vue";
import Modal from "../../components/modal.vue";
import Contact from "../../components/contact.vue";
import Loading from "../../components/loading.vue";
import Form from "../../components/form.vue";

export default {
  components: {
    Items,
    Modal,
    Contact,
    Loading,
    Form,
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.initiate();
  },
  created() {
    this.initiate();
  },
  computed: {
    ...mapState(["query", "taxonomies", "page"]),
  },
  methods: {
    ...mapMutations([
      "unsetIndices",
      "unsetTaxonomies",
      "updateTaxonomies",
      "toggleScroll",
      "toggleLoading",
    ]),
    ...mapActions(["fetchIndices", "fetchTaxonomies"]),
    initiate: function () {
      const id = this.$route.params.id;
      const taxonomy = this.$route.params.taxonomy;
      const arg = arg_html[0];
      const arr = arg_html[1];
      console.log(arr);

      this.unsetIndices();
      this.unsetTaxonomies();
      if (taxonomy) {
        this.$store.commit(
          `set${taxonomy[0].toUpperCase() + taxonomy.slice(1)}`,
          id
        );
      } else if (arg) {
        this.$store.commit(
          `set${arg[0].toUpperCase() + arg.slice(1)}`,
          Number(arr)
        );
      }
      this.toggleLoading();
      this.toggleScroll();
      window.setTimeout(() => {
        console.log(this.query);
        this.fetchIndices({ page: this.page, query: this.query });
        this.toggleLoading();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
